import React from 'react';
import { Link } from 'react-router-dom';
import styles from './LandingPage.module.css';

const LandingPage: React.FC = () => {
  return (
    <div className={styles.landingContainer}>
      <h1 className={styles.title}>XOXO Beverages</h1>
      <nav className={styles.nav}>
        <Link to="/shop-admin" className={styles.navButton}>
          Go to Shop Admin
        </Link>
      </nav>
    </div>
  );
};

export default LandingPage;

